import { useEffect,useState } from 'react';

export const useInnerWidth = (updateOnMount = false) => {
  // The updateOneMount keeps this backwards compatible.
  const [innerWidth, setInnerWidth] = useState(updateOnMount ? undefined : window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setInnerWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Update the innerWidth on mount.
  useEffect(() => {
    if (innerWidth === undefined) {
      setInnerWidth(window.innerWidth)
    }
  }, []);
  return innerWidth;
};

export default useInnerWidth;
